export default function generateAlmostUniqueId() {
  return new Date().valueOf().toString();
}
